import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { PlayIcon, ClockIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface VideoCardProps {
  id: number;
  title: string;
  titleAr: string;
  thumbnail: string;
  duration: string;
  category: string;
}
export function VideoCard({
  id,
  title,
  titleAr,
  thumbnail,
  duration,
  category
}: VideoCardProps) {
  const {
    isArabic
  } = useLanguage();
  return <Link to={`/learn/video-lessons/${id}`} className="group relative flex flex-col bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all duration-300" data-id="element-1597">
      <div className="relative aspect-video overflow-hidden" data-id="element-1598">
        <img src={thumbnail} alt={isArabic ? titleAr : title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-1599" />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1600">
          <div className="p-3 bg-blue-600 rounded-full" data-id="element-1601">
            <PlayIcon className="w-6 h-6 text-white" data-id="element-1602" />
          </div>
        </div>
        <div className="absolute bottom-2 right-2 px-2 py-1 bg-black bg-opacity-70 text-white text-xs rounded-md flex items-center" data-id="element-1603">
          <ClockIcon className="w-3 h-3 mr-1" data-id="element-1604" />
          {duration}
        </div>
      </div>
      <div className="p-4 flex-1 flex flex-col" data-id="element-1605">
        <div className="text-xs text-blue-600 dark:text-blue-400 mb-1" data-id="element-1606">
          {category}
        </div>
        <h3 className="font-medium text-gray-900 dark:text-white mb-1 line-clamp-2" data-id="element-1607">
          {isArabic ? titleAr : title}
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 line-clamp-1" data-id="element-1608">
          {isArabic ? title : titleAr}
        </p>
      </div>
    </Link>;
}